import { detailsBig, h1, h3, h5 } from "@/styles/typography";
import styled from "styled-components";

const TitleWrapper = styled.div`
  margin-top: 180px;
`;

const Div = styled.div`
  position: relative;
  margin-bottom: 1.5rem;

  p {
    position: absolute;
    color: white;
    bottom: 0;
    padding: 1rem 0.75rem 0.5rem 1rem;
    right: 0;
    font-family: Avenir next;
    text-transform: capitalize;
    font-size: 0.5rem;
  }
`;

const Container = styled.div`
  margin-bottom: 100px;
  display: grid;
  grid-template-columns: 2fr 1fr;
  grid-gap: 100px;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: ${({ theme }) => theme.colors.primary};
    margin-bottom: 20px;
    text-transform: uppercase;
  }
  
  @media ${({ theme }) => theme.breakpoints.md} {
    grid-template-columns: 1fr;
    gap: 20px;
  }
`;

const HeaderBackground = styled.div`
  position: absolute;
  top: 0;
  background-color: ${({ theme }) => theme.colors.primary};
  width: 100%;
  height: 80px;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Date = styled(detailsBig)`
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.primary};
  margin-bottom: 20px;
`;

const Title = styled(h1)`
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.primary};
  margin-bottom: 30px;
  max-width: 750px;
`;

const Excerpt = styled(h5)`
  color: #424242;
  margin-bottom: 20px;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  margin-bottom: 50px;
`;

const RelatedWrapper = styled.div`
  position: sticky;
  top: 250px;
`;

const RelatedTitle = styled(h3)``;

export const S = {
  TitleWrapper,
  Container,
  Wrapper,
  HeaderBackground,
  Date,
  Title,
  Excerpt,
  Image,
  RelatedWrapper,
  RelatedTitle,
  Div
};

export default S;
